/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tasks': {
    width: 14,
    height: 20,
    viewBox: '0 0 14 20',
    data: '<path pid="0" d="M10.874 3.101h1.761c.645 0 1.167.522 1.167 1.167v13.966c0 .644-.522 1.166-1.167 1.166H1.227A1.166 1.166 0 0 1 .06 18.234V4.268C.06 3.623.582 3.1 1.227 3.1h1.761v-.244c0-.462.374-.835.835-.835h1.11a2.06 2.06 0 0 1 3.996 0h1.11c.461 0 .835.373.835.835V3.1zm-1.972-.08a.97.97 0 0 1-.941-.748 1.06 1.06 0 0 0-2.06 0 .97.97 0 0 1-.941.749h-.972v1.054h5.886V3.022h-.972zm-4.109 6.1a1.092 1.092 0 1 0-2.183 0 1.092 1.092 0 0 0 2.183 0zm1.957.5h5.002v-1H6.75v1zm-1.957 4.383a1.092 1.092 0 1 0-2.183 0 1.092 1.092 0 0 0 2.183 0zm1.957.5h5.002v-1H6.75v1z" _fill="#BCBCBC" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/tasks.js